import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import SpriteComponent from '../../../Component/Render/Sprite';
import TransformComponent from '../../../Component/Transform';
import { delay } from '../../../Utility/Task/TaskQueue';

export class WavesIdle extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        const frames = ['WAVE1', 'WAVE2', 'WAVE3', 'WAVE2'];
        const yPositions = [4, 3, 2, 3];
        const wavesSprite = gameObject.getComponent(SpriteComponent);
        const wavesTransform = gameObject.getComponent(TransformComponent);

        const fps = 6;
        const msPerFrame = 1000 / fps;
        let currentFrame = 0;
        while (true) {
            wavesTransform.position.y = yPositions[currentFrame];
            wavesSprite.texture = frames[currentFrame];
            currentFrame = (currentFrame + 1) % frames.length;
            yield* delay(msPerFrame);
        }
    }
}
